export default __webpack_public_path__ + "static/media/Adnan Telalović.f7ac612d.jpg";